import React from 'react';
import PropTypes from 'prop-types';
import deepmerge from 'deepmerge';

import { Avatar } from '@metarouter-private/mr-mui';

import WithTooltip from 'app/components/WithTooltip';

import LOGO_MAP from 'app/components/integrations/logos';

export default function IntegrationAvatar({ starterkitId, name, imgProps = {}, ...avatarProps }) {
  const logo = LOGO_MAP[starterkitId];

  const slotProps = {
    img: imgProps,
  };

  const props = deepmerge({ slotProps }, avatarProps);

  const withTooltipProps = {
    title: name,
    show: Boolean(name),
    noContainer: true,
  };

  if (logo) {
    return (
      <WithTooltip {...withTooltipProps}>
        <Avatar {...props} src={logo} />
      </WithTooltip>
    );
  }

  const integrationCharacter = starterkitId.charAt(0).toUpperCase();
  return (
    <WithTooltip {...withTooltipProps}>
      <Avatar {...props}>{integrationCharacter}</Avatar>
    </WithTooltip>
  );
}

IntegrationAvatar.propTypes = {
  starterkitId: PropTypes.string.isRequired,
  name: PropTypes.string,
  imgProps: PropTypes.object,
};
